export const LeftArrowIcon = ({ classes, stroke = "#333", fill = "none" }) => (
  <svg data-testid="left-arrow-icon" className={classes} viewBox="0 0 18 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M0.75 9H17.25" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.75 15L0.75 9L6.75 3" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
